import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllKnockStatuses } from '@user/store/knockStatus/slice'

const CUSTOM_STATUS_LIMIT = 4

export const useD2DData = () => {
  const allStatuses = useSelector(selectAllKnockStatuses)

  const customStatuses = useMemo(
    () => allStatuses.filter((s) => !s.isSystem),
    [allStatuses],
  )

  const isAtLimit = customStatuses.length >= CUSTOM_STATUS_LIMIT

  return {
    isAtLimit,
    allStatuses,
  }
}
